import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function Impressum() {
  return <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8" data-id="element-498">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm p-8" data-id="element-499">
        <div className="mb-6" data-id="element-500">
          <Link to="/" className="flex items-center text-sm text-gray-600 hover:text-gray-800" data-id="element-501">
            <ArrowLeftIcon size={16} className="mr-1" data-id="element-502" />
            Zurück zur Startseite
          </Link>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-503">Impressum</h1>
        <div className="space-y-6 text-gray-700" data-id="element-504">
          <div data-id="element-505">
            <h2 className="text-lg font-semibold mb-2" data-id="element-506">
              Angaben gemäß § 5 TMG
            </h2>
            <p data-id="element-507">INTIGOO! GmbH</p>
            <p data-id="element-508">Werner-von-Siemens-Straße 33</p>
            <p data-id="element-509">49124 Georgsmarienhütte</p>
            <p className="mt-3" data-id="element-510">Handelsregister: HRB 217224</p>
            <p data-id="element-511">Registergericht: Amtsgericht Osnabrück</p>
            <p className="mt-3" data-id="element-512">Vertreten durch:</p>
            <p data-id="element-513">Fabian Kleine Huxel</p>
            <p data-id="element-514">Felix Höfelmeyer</p>
          </div>
          <div data-id="element-515">
            <h2 className="text-lg font-semibold mb-2" data-id="element-516">Kontakt</h2>
            <p data-id="element-517">Telefon: +49 5401 1689580</p>
            <p data-id="element-518">E‑Mail: info@intigoo.de</p>
          </div>
          <div data-id="element-519">
            <h2 className="text-lg font-semibold mb-2" data-id="element-520">Umsatzsteuer-ID</h2>
            <p data-id="element-521">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a
              Umsatzsteuergesetz:
            </p>
            <p data-id="element-522">DE 349819653</p>
          </div>
          <div data-id="element-523">
            <h2 className="text-lg font-semibold mb-2" data-id="element-524">EU-Streitschlichtung</h2>
            <p data-id="element-525">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:
              <a href="https://ec.europa.eu/consumers/odr/" className="text-[#3498dd] hover:underline ml-1" target="_blank" rel="noopener noreferrer" data-id="element-526">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p data-id="element-527">Unsere E‑Mail-Adresse finden Sie oben im Impressum.</p>
          </div>
          <div data-id="element-528">
            <h2 className="text-lg font-semibold mb-2" data-id="element-529">
              Verbraucherstreitbeilegung / Universalschlichtungsstelle
            </h2>
            <p data-id="element-530">
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </div>
        </div>
      </div>
    </div>;
}